import { z } from '@hono/zod-openapi'
import { clientVendorAccessTable } from '@mattrika/benefit-db'
import { createSelectSchema } from 'drizzle-orm/zod'
import { zPassword } from '../common/common.model'
import { zSelectDomain } from '../domains/domains.zod'
import { zSelectUser } from '../user/user.zod'
import { zQueryClients, zSelectClient } from './client.zod'

export const zRegisterClient = z.object({
    firstName: z.string().min(1, { message: 'First name is required' }),
    lastName: z.string().min(1, { message: 'Last name is required' }),
    email: z.email().trim().toLowerCase(),
    password: zPassword,
    organizationName: z
        .string()
        .min(1, { message: 'Organization name is required' }),
    contactPhone: z.string().optional(),
    contactEmail: z.email().trim().toLowerCase(),
    domains: z.string().array(),
})

export const zUpdateClientStatus = zQueryClients.pick({ status: true })

export type RegisterClient = z.infer<typeof zRegisterClient>
export type UpdateClientStatus = z.infer<typeof zUpdateClientStatus>

export const zSelectClientVendorAccess = createSelectSchema(
    clientVendorAccessTable,
)

export const zClientVendorAccessWithVendor = zSelectClientVendorAccess.extend({
    vendorName: z.string().nullable(),
    vendorLogoUrl: z.string().nullable(),
    categoryName: z.string().nullable(),
})

export type ClientVendorAccessWithVendor = z.infer<
    typeof zClientVendorAccessWithVendor
>

export const zClientDetails = zSelectClient.extend({
    domains: z.array(zSelectDomain),
    users: z.array(zSelectUser),
    benefitApplicationsCount: z.number(),
})

export type ClientDetails = z.infer<typeof zClientDetails>
